import { useEffect } from 'react';
import { useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import {
  fetchImport,
  fetchLastImport,
  startSyncImport,
} from '@/store/slices/importSlice';
import { useNavigate } from 'react-router';
import { RootState } from '@/store/store';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const Import = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { lastImport, importing } = useSelector(
    (state: RootState) => state.import
  );

  useEffect(() => {
    dispatch(fetchLastImport());

    let interval = null;

    if (importing) {
      interval = setInterval(() => {
        dispatch(fetchLastImport());
      }, 5000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [dispatch, importing]);

  const handleImport = () => {
    dispatch(startSyncImport());

    dispatch(fetchImport());
  };

  return (
    <div className="flex items-center gap-1 text-white">
      <div className="font-medium">Opdateret | {lastImport}</div>
      <ArrowPathIcon
        onClick={handleImport}
        className={`size-5 cursor-pointer transition-transform duration-500 ${
          importing ? 'animate-spin' : 'hover:rotate-180'
        }`}
      />
    </div>
  );
};

export default Import;
